import React, {useState, useEffect} from 'react';
import {gql} from "@apollo/client";
import client from '../../../src/graphql/client';
import {get} from 'lodash';
import qs from 'qs';
import styled from '@emotion/styled';
import Router from 'next/router';
import {Grid, Box} from '@mui/material';
import seoQuery from '../../../src/graphql/queries/seo';
import contentBuilderQuery from '../../../src/graphql/queries/content-builder';
import refactorHb from '../../../src/data-restructure/multimedia/hero-banner';
import refactorHBCData from '../../../src/data-restructure/multimedia/hero-banner-carousel';

import {theme} from '../../../src/themes/default-theme';

// components
import FormContainer from '../../../src/containers/Forms/FormContainer';
import Text from '../../../src/components/typography';

import bannerAsset from '../../../src/assets/brochure-pattern.png';

const Container = styled.div`
  margin-bottom: -30px;
  background-color: #F3F4F7;
  padding-bottom: 195px;

  > div:last-child {
    width: 100%;
    margin: auto;
    max-width: 492px;
    padding-left: 20px;
    padding-right: 20px;
  }

  h4 {
    color: #2E3238;
    font-size: 20px;
    font-style: normal;
    font-weight: 800;
    line-height: 24px;
    text-transform: uppercase;
  }
`

const TopBanner = styled.div`
  width: 100%;
  height: 56px;
  display: block;
  background-image: url(${bannerAsset});
  background-size: 1600px;
  background-position: bottom;
`

const TitleContainer = styled.div`
  margin-top: 60px;
  margin-bottom: 60px;
`

const BrochureRequestForm = (props) => {

  const {
    country
  } = props

  const [data, updateData] = useState('')

  useEffect(() => {
    const currentQsData = qs.parse(window.location.search.replace('?',''));
    if (!get(currentQsData, 'items', null)) {
      const redirectUrl = '/brochure-request';
      process.env.NODE_ENV === 'development' ?
        window.location.href = redirectUrl
      :
      Router.push(redirectUrl);
    } else {
      updateData(currentQsData);
      console.log('currentQsData url', encodeURI(`${window.location.origin}/brochure-request/form/thank-you?items=${currentQsData.items.map(item => item.link).join('+')}`));
    }

  }, []);

  console.log('data', data);

  const dealerTitle = typeof window !== 'undefined' && process.env.DEALER_SITE ? window.staticly.dealerData.name : "{{data.template.dealer.name}}";
  

  return (
    <Container>
      <TopBanner />
      <Grid container direction={'row'} justifyContent={'space-between'} alignItems={'flex-start'}>
        <Grid size={12}>
          <Box px={2}>
            <TitleContainer>
              <Text variant="h1" align="center" uppercase colour="charcoal">REQUEST A BROCHURE</Text>
            </TitleContainer>
          </Box>
        </Grid>
      </Grid>
      {(data && data.items) && 
        <FormContainer
          // sugarSubmit={true}
          formId="brochure_request"
          thankYouUrl={encodeURI(`${window.location.origin}/brochure-request/form/thank-you?items=${data.items.map(item => item.link).join('+')}`)}
          formTitle="Your details"
          padding={false}
          background={'transparent'}
          topo={false}
          formItems={[
            {
              type:  'hidden',
              name: 'brochures',
              value: data && data.items ? JSON.stringify(data.items) : '',
            },
            {
              type: 'name',
              name: 'first_name',
              label: 'first_name',
              placeholder: 'First name*',
              required: true,
              errorText: 'This field is required',
            },
            {
              type: 'name',
              name: 'last_name',
              label: 'last_name',
              placeholder: 'Last name*',
              required: true,
              errorText: 'This field is required',
            },
            {
              type: 'email',
              name: 'email',
              label: 'email',
              placeholder: 'Email*',
              required: true,
              errorText: 'Please add a valid email address',
            },
            {
              type: 'postcode',
              name: 'postcode',
              label: 'Postcode',
              placeholder: "Postcode*",
              required: true,
              errorText: 'Please enter a valid postcode',
            },
            {
              type: 'label',
              label: 'Share brochure/s with someone'
            },
            {
              type: 'email',
              name: 'recipient',
              label: 'recipient',
              placeholder: "Recipient's email",
              required: false,
              errorText: 'Please add a valid email address',
            },
            {
              type: 'textarea',
              name: 'message',
              label: 'message',
              placeholder: 'Message',
              required: false,
              rows: 5
            },
            {
              type: 'checkbox',
              margin: 'none',
              name: 'e_newsletter',
              label: `Sign me up for ${process.env.DEALER_SITE ? `${dealerTitle}'s` : `Jayco ${country}`} e-Newsletter`,
            },
            {
              type: 'checkbox',
              margin: 'none',
              name: 'privacy',
              label: `I have read and agree to ${process.env.DEALER_SITE ? `${dealerTitle}'s` : `Jayco ${country}`} <a href="/privacy" target="_blank">Privacy&nbsp;Policy</a>*`,
              required: true,
              errorText: 'This field is required',
            }
          ]}
        />
      }
    </Container>
  );
}

BrochureRequestForm.propTypes = {

}

export async function getStaticProps() {
  const countryCode = process.env.DEV_COUNTRY_CODE ? process.env.DEV_COUNTRY_CODE : process.env.COUNTRY_CODE;

  const GET_BR_DATA = gql`
    query GET_BR_DATA {
      pageBy(uri: "request-a-brochure?${countryCode.toLowerCase()}") {
        title
        seo {
          ${seoQuery}
        }
        ${contentBuilderQuery()}
        acf_domains {
          assignedDomains
        }
      }
    }
  `

  const result = await client.query({
    query: GET_BR_DATA,
  });

  const context = get(result, 'data.pageBy', {});
  const cbData = get(result, 'data.pageBy.acf_content_builder.contentBuilder', null);

  // Hero banner
  const hasBanner = get(cbData, '[0].fieldGroupName', '') === 'page_AcfContentBuilder_ContentBuilder_FcSingleHeroBanner';
  const heroBanner = hasBanner ? refactorHb(cbData[0]) : null;

  // Banner carousel
  const hasCarousel = get(cbData, '[0].fieldGroupName', '') === 'page_AcfContentBuilder_ContentBuilder_FcHeroBannerCarousel';
  const heroBannerCarousel = hasCarousel ? refactorHBCData(cbData[0]) : null;

  const country = countryCode === 'AU' ? "Australia's" : "New Zealand's";

  const assignedDomains = get(result, 'data.pageBy.acf_domains.assignedDomains', []); 

  return {
    revalidate: (process.env.NEXT_STATIC_EXPORT && process.env.NEXT_STATIC_EXPORT.toString() === 'true') ? false : 1,
    props: {
      meta: {
        title: context?.title ? context.title : null,
        seo: context?.seo ? context.seo : null,
        assignedDomains,
        noIndex: true
      },
      heroBanner,
      heroBannerCarousel,
      country
    }
  }
}


export default BrochureRequestForm
